import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
  font_xl,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.AutomationRulesSettings {
    width: 100%;
    margin-bottom: ${spacing(6)};

    .accounting-rules-settings-box {
      display: flex;
      flex-direction: column;
      gap: ${spacing(6)};
      padding: ${spacing(10)};

      .settings-box {
        padding: ${spacing(6)};
      }
    }

    .gradient-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: ${spacing(1)};
      background: linear-gradient(135deg, #8b5cf6 0%, #9c92fb 100%);
      flex-shrink: 0;
    }

    .header-title {
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_xl};
    }

    /* Content container with cards */
    .content-container {
      display: flex;
      flex-direction: column;
      gap: ${spacing(6)};
    }

    .settings-box {
      /* Box component handles the border and background */
    }

    .box-content {
      display: flex;
      gap: ${spacing(6)};
      align-items: center;
      justify-content: space-between;
    }

    .text-section {
      display: flex;
      flex-direction: column;
      gap: ${spacing(3)};
      flex: 0 1 60%;
    }

    .title-row {
      display: flex;
      align-items: center;
      gap: ${spacing(1)};
    }

    .title {
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_lg};
    }

    .beta-pill {
      /* BetaTag component handles its own styling */
    }

    .description {
      color: ${text_colorTextSecondary};
      font-family: ${font_family_weight_regular};
      ${font_md};
    }

    .switch-container {
      flex-shrink: 0;
    }
  }
`
